import React from "react";
import styled from "styled-components";

const Switch = ({ darkMode, setDarkMode, size = "md" }) => {
  return (
    <StyledWrapper size={size}>
      <label className="switch">
        <input
          type="checkbox"
          checked={darkMode}
          onChange={() => setDarkMode(!darkMode)}
        />
        <span className="slider" />
      </label>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .switch {
    display: block;
    /* Switch size will scale based on props */
    --width-of-switch: ${({ size }) =>
      size === "sm" ? "2.5em" : size === "lg" ? "4.5em" : "2.8em"};
    --height-of-switch: ${({ size }) =>
      size === "sm" ? "1.4em" : size === "lg" ? "2.5em" : "1.5em"};
    --size-of-icon: ${({ size }) =>
      size === "sm" ? "1em" : size === "lg" ? "1.8em" : "1.2em"};
    --slider-offset: ${({ size }) =>
      size === "sm" ? "0.2em" : size === "lg" ? "0.35em" : "0.3em"};
    position: relative;
    width: var(--width-of-switch);
    height: var(--height-of-switch);
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #dbdbdcff;
    transition: 0.4s;
    border-radius: 30px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: var(--size-of-icon);
    width: var(--size-of-icon);
    border-radius: 20px;
    left: var(--slider-offset);
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(40deg, #ff0080, #ff8c00 70%);
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #303136;
  }

  input:checked + .slider:before {
    left: calc(
      100% - (var(--size-of-icon) + var(--slider-offset))
    );
    background: #303136;
    box-shadow: inset -3px -2px 5px -2px #8983f7,
      inset -10px -4px 0 0 #a3dafb;
  }
`;

export default Switch;
